module.exports = __webpack_public_path__ + "static/media/LOGO-medium.e5708d2f.png";